<vw-card customClasses="bg-white">
  <div class="p-4">
    <div class="flex items-start justify-between">
      <div class="flex-1 pr-2">
        <h3 class="text-lg font-semibold text-[#023E42] truncate">{{ bed.name }}</h3>
        <p class="text-xs text-[#9DA4A2]">{{ 'garden.beds.type.' + bed.type | translate }}</p>
      </div>
      <span class="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-[#6B7472]">{{ dimensionLabel }}</span>
    </div>

    <!-- Aperçu des cultures -->
    @if (plants.length) {
      <div class="mt-3 flex gap-2">
        @for (p of previewPlants; track p.uid) {
          <div class="h-12 w-12">
            <vw-cultivation-item-viewer [cultivation]="$any(p.cultivationVariant)" displayType="SMALL"></vw-cultivation-item-viewer>
          </div>
        }
        @if (extraCount > 0) {
          <div class="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-200 text-sm text-white">+{{ extraCount }}</div>
        }
      </div>
    }

    <p class="mt-3 flex items-center gap-1 text-xs text-[#9DA4A2]">
      <span>🌱 {{ 'garden.overview.cultures-count' | translate: { count: plants.length } }}</span>
      <span>·</span>
      <span>{{ 'garden.overview.free-cells' | translate: { count: freeCells } }}</span>
    </p>
  </div>
</vw-card>
